/**
 * Navigation Enhancement
 * Adds wiki links to existing Ghost navigation
 */

class NavigationEnhancer {
    constructor() {
        this.init();
    }

    init() {
        this.addWikiToHeader();
        this.addWikiToFooter();
    }

    addWikiToHeader() {
        const headerMenu = document.querySelector('.gh-head-menu .nav');
        if (headerMenu && !this.hasWikiLink(headerMenu)) {
            const wikiLink = this.createWikiLink('header');
            headerMenu.appendChild(wikiLink);
        }
    }

    addWikiToFooter() {
        const footerMenu = document.querySelector('.gh-foot-menu .nav');
        if (footerMenu && !this.hasWikiLink(footerMenu)) {
            const wikiLink = this.createWikiLink('footer');
            footerMenu.appendChild(wikiLink);
        }
    }

    hasWikiLink(menu) {
        return menu.querySelector('.nav-wiki') !== null;
    }

    createWikiLink(type) {
        const li = document.createElement('li');
        li.className = 'nav-wiki';
        li.setAttribute('role', 'presentation');

        const a = document.createElement('a');
        a.href = '/wiki/';
        a.textContent = 'Wiki';
        
        // Add active state if on wiki page
        if (window.location.pathname.startsWith('/wiki')) {
            li.classList.add('nav-current');
        }

        li.appendChild(a);
        return li;
    }
}

// Initialize navigation enhancement when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new NavigationEnhancer();
});
